import { FormControlKey } from './';
export var createFormControlDriver = function (wrapper, direct) {
    if (direct === void 0) { direct = false; }
    var base = direct ? wrapper : wrapper.$("." + FormControlKey);
    return {
        label: function () { return base.$('.label').text(); },
        hasLabel: function () { return base.$('.label').exists(); },
        hasError: function () { return base.$('.validation-error').exists(); },
        errorMessage: function () { return base.$('.validation-error').text(); },
        ariaLabel: function () { return base.attr('aria-label'); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map